import { queryOptions } from "@tanstack/react-query";
import {
  getMapRotation as getGeneratedMapRotation,
  getPlayerStatistics as getGeneratedPlayerStatistics,
  getPredatorThreshold as getGeneratedPredatorThreshold,
  getServerStatus as getGeneratedServerStatus,
  getUpLiveStatus as getGeneratedUpLiveStatus,
} from "@/lib/api/generated/endpoints/apex/apex";
import type {
  MapRotationData,
  PlayerStatisticsData,
  PredatorThresholdData,
  ServerStatusData,
} from "@/lib/models/apex";
import type { UpLiveStatus } from "@/lib/models/bilibili";

export async function getUpLiveStatus() {
  return (await getGeneratedUpLiveStatus()) as UpLiveStatus;
}

export async function getMapRotation() {
  return (await getGeneratedMapRotation()) as MapRotationData;
}

export async function getPredatorThreshold() {
  return (await getGeneratedPredatorThreshold()) as PredatorThresholdData;
}

export async function getServerStatus() {
  return (await getGeneratedServerStatus()) as ServerStatusData;
}

export async function getPlayerStatistics(params: {
  player: string;
  platform?: "PC" | "PS4" | "X1";
}) {
  return (await getGeneratedPlayerStatistics(params)) as PlayerStatisticsData;
}

export const mapRotationQueryOptions = queryOptions({
  queryKey: ["apex", "map-rotation"],
  queryFn: () => getMapRotation(),
  staleTime: 3000,
});

export const predatorThresholdQueryOptions = queryOptions({
  queryKey: ["apex", "predator-threshold"],
  queryFn: () => getPredatorThreshold(),
  staleTime: 10000, // 30 seconds
  refetchInterval: 10000, // 30 seconds
});

export const serverStatusQueryOptions = queryOptions({
  queryKey: ["apex", "server-status"],
  queryFn: () => getServerStatus(),
  staleTime: 10000, // 10 seconds
  refetchInterval: 10000, // 10 seconds
});
